var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon32Warning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-32-warning",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding_box",
    "data-name": "Bounding box",
    width: 32,
    height: 32,
    fill: "rgba(255,255,255,0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_color",
    "data-name": "Icon color",
    d: "M28.8,27H1.2a.991.991,0,0,1-.873-.54l-.191-.327a1.157,1.157,0,0,1,0-1.079L13.922.526A1.034,1.034,0,0,1,14.809,0h.409A1.033,1.033,0,0,1,16.1.526L29.865,25.053a1.15,1.15,0,0,1,0,1.079l-.19.327A.992.992,0,0,1,28.8,27ZM15,4.263,3.8,24.158h22.38L15,4.263Zm.682,17.054H14.318a.7.7,0,0,1-.682-.711V19.184a.7.7,0,0,1,.682-.711h1.363a.7.7,0,0,1,.682.711v1.421A.7.7,0,0,1,15.682,21.316Zm-1.408-5.685a.346.346,0,0,1-.339-.312l-.545-4.576a.733.733,0,0,1,.168-.559.669.669,0,0,1,.509-.237h1.86a.674.674,0,0,1,.513.237.73.73,0,0,1,.169.559l-.546,4.576a.346.346,0,0,1-.339.312H14.274Z",
    transform: "translate(1 2)",
    fill: "#ff3838"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon32Warning);
export default __webpack_public_path__ + "static/media/icon-32-warning.118c877bb8a23468197baf067ba24adc.svg";
export { ForwardRef as ReactComponent };